import { useState } from 'react';
import useAPI from '../../../hooks/useAPI';

export const ALUNOS_FILTERS = {
  SEARCH: 'search'
}

const buildAlunosUrl = ({ baseUrl, page, rowsPerPage, filters }) => {
  const query = {
    page: page + 1,
    limit: rowsPerPage,
    additional_fields: 'celular',
    ...(filters?.[ALUNOS_FILTERS.SEARCH] && {search: filters[ALUNOS_FILTERS.SEARCH]}),
  }

  const queryParams = new URLSearchParams(query);

  return `${baseUrl}?${queryParams.toString()}`;
}

export default function useAlunos() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filters, setFilters] = useState({});

  const { data, headers, isLoading, refreshData } = useAPI(buildAlunosUrl({ baseUrl: '/alunos', page, rowsPerPage, filters }));

  const changePage = (newPage) => {
    setPage(newPage);
  }

  const changeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    changePage(0);
  }

  const changeFilters = (newFilters) => {
    setFilters(newFilters);
    changePage(0);
  }

  const resetFilters = () => {
    changeFilters({});
  }

  return {
    data,
    total: headers?.['x-total-count'],
    isLoading,
    page,
    rowsPerPage,
    filters,
    changePage,
    changeRowsPerPage,
    changeFilters,
    resetFilters,
    refreshData
  };
}